import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, isRef as _isRef, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderSlot as _renderSlot, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a323ee34"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tips" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("为了保证数据导入顺利，推荐您下载使用 ")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("导入模版")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("导入模版")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("，并按照规范示例录入数据。 ")
const _hoisted_6 = { class: "standard" }

import { ref, computed } from "vue";
import UploadArea from "@/views/organization/component/multiple-import/upload-area/index.vue";
import { CloudDownloadOutlined } from "@ant-design/icons-vue";


import { defineComponent } from "vue";
const __default__ = defineComponent({
  name: "SelectFile",
});

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  loadingRequest: {
    type: Boolean,
    default: false,
  },
  modelUrl: {
    type: String,
  },
  templateKey:{
    type: String,
  }
},
  emits: ["finishUpload"],
  setup(__props, { emit }) {

const props = __props





const uploading = ref(false);

const calcLoading = computed({
  get() {
    return props.loadingRequest && uploading.value;
  },
  set(val: boolean) {
    uploading.value = val;
  },
});

function finishSelect(url) {
  url && emit("finishUpload", url);
}

return (_ctx: any,_cache: any) => {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_download_template_btn = _resolveComponent("download-template-btn")!
  const _component_a_space = _resolveComponent("a-space")!

  return (_openBlock(), _createBlock(_component_a_space, {
    direction: "vertical",
    size: 20,
    class: "container"
  }, {
    default: _withCtx(() => [
      _createVNode(UploadArea, {
        calcLoading: _unref(calcLoading),
        "onUpdate:calcLoading": _cache[0] || (_cache[0] = ($event: any) => (_isRef(calcLoading) ? (calcLoading).value = $event : null)),
        onGetFileUrl: finishSelect
      }, null, 8, ["calcLoading"]),
      _createElementVNode("h3", _hoisted_1, [
        _createVNode(_unref(CloudDownloadOutlined), { style: {"margin-right":"10px"} }),
        _hoisted_2,
        (__props.modelUrl&&__props.modelUrl!='')
          ? (_openBlock(), _createBlock(_component_a_button, {
              key: 0,
              type: "link",
              class: "template-link",
              href: __props.modelUrl
            }, {
              default: _withCtx(() => [
                _hoisted_3
              ]),
              _: 1
            }, 8, ["href"]))
          : (_openBlock(), _createBlock(_component_download_template_btn, {
              key: 1,
              "template-key": __props.templateKey
            }, {
              default: _withCtx(() => [
                _hoisted_4
              ]),
              _: 1
            }, 8, ["template-key"])),
        _hoisted_5
      ]),
      _createElementVNode("div", _hoisted_6, [
        _renderSlot(_ctx.$slots, "standard")
      ])
    ]),
    _: 3
  }))
}
}

})